<template>
  <div>
    <PageTitle :route="$route">
      <!-- <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template> -->
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <IntegratorList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import IntegratorList from '@/components/settings/integrador/integrator/IntegratorList'
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "Integrators",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    IntegratorList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addintegratorsettings" });
    },
  },
};
</script>
